import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import camera from './camera';
import calculations, * as fromCalculations from './calculations';
import resins, * as fromResins from './resins';
import stackup, * as fromStackup from './stackup';
import startNewForm, * as fromStartNewForm from './startNewForm';
import current, * as fromCurrent from './current';
import preference, * as fromPreference from './preference';

const stackupApp = combineReducers({
  camera,
  calculations,
  resins,
  stackup,
  startNewForm,
  form: reduxFormReducer,
  current,
  preference,
});

export default stackupApp;

export function getManufacturers(state) {
  return fromResins.getManufacturers(state.resins);
}

export function getIsStartNewFormValid(state) {
  return fromStartNewForm.getIsFormValid(state.startNewForm);
}

export function getStartNewFormConfig(){
  return fromStartNewForm.getFormConfig();
}

export function getResinIdFromStartNewForm(state){
  return fromStartNewForm.getResinId(state.startNewForm);
}

export function getManufacturerIdFromStartNewForm(state){
  return fromStartNewForm.getManufacturerId(state.startNewForm);
}

export function getResinsByManufacturerId(state, manufacturerId){
  return fromResins.getResinsWithManufacturerId(state.resins, manufacturerId);
}

export function getResinById(state, resinId){
  return fromResins.getResinById(state.resins, resinId);
}

export function getDefaultCore(state, resinId){
  return fromResins.getDefaultCore(state.resins, resinId);
}

export function getDefaultPrepreg(state, resinId){
  return fromResins.getDefaultPrepreg(state.resins, resinId);
}

export function getCoreOptionsByResinId(state, resinId){
   return fromResins.getCoreOptionsByResinId(state.resins, resinId);
}

export function getPrepregOptionsByResinId(state, resinId){
   return fromResins.getPrepregOptionsByResinId(state.resins, resinId);
}

export function getStackup(state) {
  return fromStackup.getStackup(state.stackup);
}

export function getStackupToExport(state) {
  return fromStackup.getStackupToExport(state.stackup);
}

export function getStackupLayers(state) {
  return fromStackup.getStackupLayers(state.stackup);
}

export function getStackupLayer(state, key){
  return fromStackup.getStackupLayer(state.stackup, key);
}

export function getMirrorLayer(state, index) {
  return fromStackup.getMirrorLayer(state.stackup, index);
}

export function getMirrorNeighborPrepreg(state, index /*, above */) {
  return fromStackup.getMirrorNeighborPrepreg(state.stackup, index);
}

export function getStackupType(state) {
  return fromStackup.getStackupType(state.stackup);
}

export function getDefaultCoreSpec(state){
  return fromStackup.getDefaultCoreSpec(state.stackup);
}

export function getDefaultPrepregSpec(state){
  return fromStackup.getDefaultPrepregSpec(state.stackup);
}

export function getDefaultInnerCopperSpec(state){
  return fromStackup.getDefaultInnerCopperSpec(state.stackup);
}

export function getDefaultResinId(state) {
  return fromStackup.getDefaultResinId(state.stackup);
}

export function getExtraCoreCount(state) {
  return fromStackup.getExtraCoreCount(state.stackup);
}

export function getNeighborPrepreg(state, currentIndex, above) {
  return fromStackup.getNeighborPrepreg(state.stackup, currentIndex, above);
}

export function getCoreMaterialsInUse(state) {
  return fromStackup.getCoreMaterialsInUse(state.stackup);
}

export function getPrepregMaterialsInUse(state) {
  return fromStackup.getPrepregMaterialsInUse(state.stackup);
}

export function getCoppersInUse(state) {
  return fromStackup.getCoppersInUse(state.stackup);
}

export function getCopperCount(state) {
  return fromStackup.getCopperCount(state.stackup);
}

export function getProjectTitle(state) {
  return fromStackup.getProjectTitle(state.stackup);
}

export function getCalculations(state) {
  return fromCalculations.getCalculations(state.calculations);
}

export function getPressedThickness(state) {
  return fromCalculations.getPressedThickness(state.calculations);
}

export function getTotalThickness(state) {
  return fromCalculations.getTotalThickness(state.calculations);
}

export function getImpedanceModelings(state) {
  return fromCalculations.getImpedanceModelings(state.calculations);
}

export function getCharacteristicImpedanceChartData(state) {
  return fromCalculations.getCharacteristicImpedanceChartData(state.calculations);
}

export function getDifferentialImpedanceChartData(state) {
  return fromCalculations.getDifferentialImpedanceChartData(state.calculations);
}

export function getPropagationDelayChartData(state) {
  return fromCalculations.getPropagationDelayChartData(state.calculations);
}

export function getAvailableImpedanceMhzs(state) {
  return fromCalculations.getAvailableImpedanceMhzs(state.calculations);
}

export function getImpedanceDisplayMhz(state) {
  return fromCalculations.getImpedanceDisplayMhz(state.calculations);
}

export function getHoveredLayer(state) {
  return fromCurrent.getLayer(state.current);
}

export function getLengthUnit(state) {
  return fromPreference.getLengthUnit(state.preference);
}


// WEBPACK FOOTER //
// ./src/reducers/index.js